import dayjs from 'dayjs';

const advancedFormat = require('dayjs/plugin/advancedFormat');
const relativeTime = require('dayjs/plugin/relativeTime');
const localizedFormat = require('dayjs/plugin/localizedFormat');

dayjs.locale('en');

export const formatCreatedAtTimeForProfileHistory = (date) => {
	dayjs.extend(advancedFormat);
	return dayjs.unix(date).format('Do MMM, YYYY | h:mm A');
};
export const formatToFromNow = (date) => {
	dayjs.extend(relativeTime);
	return dayjs(date * 1000).fromNow();
};

export const formatEndDateForActivePlans = (date) => {
	const utcSeconds = date;
	const localDate = new Date(0);
	localDate.setUTCSeconds(utcSeconds);
	return dayjs(localDate).format('MMM D, YYYY');
};
export const formatEndDateForFreePlan = (date) => {
	const utcSeconds = date;
	const localDate = new Date(0);
	localDate.setUTCSeconds(utcSeconds);
	dayjs.extend(localizedFormat);
	return dayjs(localDate).format('LT');
};

export const secondsToTimeString = (seconds) => {
	if (seconds <= 0) {
		return '0 sec';
	}

	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

	let timeString = '';
	if (minutes > 0) {
		timeString += `${minutes}min `;
	}
	timeString += `${formattedSeconds}sec`;

	return timeString;
};
